import React, { useState, useEffect } from "react";
import { Box, Typography, TextField, Button, MenuItem, Grid, Switch, FormControlLabel } from "@mui/material";

const ChannelForm = ({ handleClose, handleSubmit, initialData }) => {
  const [formData, setFormData] = useState({
    name: "",
    channel_type: "",
    commission_rate: "",
    markup_rate: "",
    currency: "INR",
    api_credentials: "",
    is_active: true
  });

  const channelTypes = ['OTA', 'GDS', 'DIRECT', 'WHOLESALE', 'METASEARCH'];

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
  };

  return (
    <Box component="form" onSubmit={onSubmit} sx={{ p: 2, bgcolor: "background.paper", borderRadius: 2, boxShadow: 1 }}>
      <Typography variant="h6" sx={{ fontSize: 16, fontWeight: "600", color: "#000", fontFamily: "Public Sans", mb: 2 }}>
        {initialData ? 'Update Channel' : 'New Channel'}
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            required
            fullWidth
            size="small"
            name="name"
            label="Channel Name"
            value={formData.name}
            onChange={handleChange}
            sx={{ "& .MuiInputBase-root": { height: "35px" } }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            required
            fullWidth
            size="small"
            select
            name="channel_type"
            label="Channel Type"
            value={formData.channel_type}
            onChange={handleChange}
            sx={{ "& .MuiInputBase-root": { height: "35px" } }}
          >
            {channelTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            required
            fullWidth
            size="small"
            name="commission_rate"
            label="Commission Rate"
            type="number"
            inputProps={{ step: "0.01", min: "0", max: "99.99" }}
            value={formData.commission_rate}
            onChange={handleChange}
            sx={{ "& .MuiInputBase-root": { height: "35px" } }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            required
            fullWidth
            size="small"
            name="markup_rate"
            label="Markup Rate"
            type="number"
            inputProps={{ step: "0.01", min: "0", max: "99.99" }}
            value={formData.markup_rate}
            onChange={handleChange}
            sx={{ "& .MuiInputBase-root": { height: "35px" } }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            required
            fullWidth
            size="small"
            name="currency"
            label="Currency"
            value="INR"
            onChange={handleChange}
            sx={{ "& .MuiInputBase-root": { height: "35px" } }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            size="small"
            name="api_credentials"
            label="API Credentials"
            multiline
            rows={4}
            value={formData.api_credentials}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Switch
                checked={formData.is_active}
                onChange={(e) => handleChange({
                  target: { name: 'is_active', value: e.target.checked }
                })}
                name="is_active"
              />
            }
            label="Active Status"
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 2 }}>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary">
          {initialData ? 'Update' : 'Save'}
        </Button>
      </Box>
    </Box>
  );
};

export default ChannelForm;
